import secondaryComponents from "../../../../components/secondaryComponents";
import { motion } from "framer-motion";
import styles from "./SupplierDetails.module.scss";
import { BackButton } from "../../../../components/primaryComponents";
import {
  defaultDateDisplay,
  formatCurrency,
  getStoreNames,
} from "../../../../helpers";
import useSupplierDetails from "./useSupplierDetails";
import { useSelector } from "react-redux";
import globalStyles from "../../../../assets/styles/base/globalPage.module.scss";

const SupplierDetails = () => {
  const {
    isFetchingSupplierDetails,
    supplierDetails,
    isFetchingInvoice,
    invoices,
    gotoPage,
  } = useSupplierDetails();
  const { currency_code } = useSelector(
    (state) => state.profileDetailsReducer.businessDetails,
  );
  const { storeList } = useSelector((state) => state.profileDetailsReducer);

  return (
    <secondaryComponents.MetaSetter
      title="Lumi Merchant | Supplier Details"
      description="View supplier details"
    >
      <secondaryComponents.RequestLoaderTrigger>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          className={`${globalStyles.pageColumnGaps} ${styles.supplierDetails}`}
        >
          <div>
            <BackButton />
          </div>

          <secondaryComponents.LoaderHelper
            classNames="mt-5"
            isLoading={isFetchingSupplierDetails}
          >
            <div>
              <h3>{supplierDetails?.name}</h3>
              <p>
                Last Updated &nbsp;
                {defaultDateDisplay(supplierDetails?.updated_at)}
              </p>
            </div>

            <div>
              <div className={styles.supplierDetails__card}>
                <div>
                  <h6>Contact Name</h6>
                  <p>{supplierDetails?.contact_name}</p>
                </div>
                <div>
                  <h6>Stores</h6>
                  <p>
                    {getStoreNames(supplierDetails?.stores, storeList) || "N/A"}
                  </p>
                </div>
                <div>
                  <h6>Contact Address</h6>
                  <p>{supplierDetails?.address}</p>
                </div>
                <div>
                  <h6>Phone Number</h6>
                  <p>{supplierDetails?.phone_number}</p>
                </div>
                <div>
                  <h6>Credit Till Date</h6>
                  <p>
                    {formatCurrency({
                      value: supplierDetails?.total_credit,
                      currencyCode: currency_code,
                    })}
                  </p>
                </div>
                <div>
                  <h6>Total Repayment</h6>
                  <p>
                    {formatCurrency({
                      value: supplierDetails?.total_repayment,
                      currencyCode: currency_code,
                    })}
                  </p>
                </div>
                <div>
                  <h6>Outstanding Balance</h6>
                  <p>
                    {formatCurrency({
                      value: supplierDetails?.total_outstanding_balance,
                      currencyCode: currency_code,
                    })}
                  </p>
                </div>
              </div>
            </div>
          </secondaryComponents.LoaderHelper>

          <secondaryComponents.LoaderHelper
            classNames="mt-5"
            isLoading={isFetchingInvoice}
          >
            <div>
              <h5>Invoices</h5>
              <secondaryComponents.InvoiceTable
                invoices={invoices}
                // refetchSupplierInvoices={refetchSupplierInvoices}
                gotoPage={gotoPage}
                supplierDetails={supplierDetails}
              />
            </div>
          </secondaryComponents.LoaderHelper>
        </motion.div>
      </secondaryComponents.RequestLoaderTrigger>
    </secondaryComponents.MetaSetter>
  );
};
export default SupplierDetails;
